import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API, setToken, isAuthenticated } from "../App";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2 } from "lucide-react";
import { useEffect } from "react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated()) {
      navigate("/");
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(`${API}/auth/login`, {
        email,
        password,
      });
      setToken(response.data.token);
      navigate("/");
    } catch (err) {
      // Traduzir mensagem de erro para português
      const errorMsg = err.response?.data?.detail || err.response?.data?.error || "Credenciais inválidas";
      const translatedError = errorMsg === "Invalid credentials" ? "Credenciais inválidas" : errorMsg;
      setError(translatedError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#000000] flex items-center justify-center p-4">
      {/* Background with overlay */}
      <div
        className="fixed inset-0 z-0"
        style={{
          backgroundImage: `url('https://storage.linkia.lat/construtor-site/1df8c31c-2070-4dfd-94b1-d92916b2b6fe.webp')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/70 backdrop-blur-sm"></div>
      </div>

      {/* Login Card */}
      <div
        data-testid="login-card"
        className="relative z-10 w-full max-w-sm bg-[#0A0A0A] border border-[#222222] p-8 shadow-2xl shadow-black/50"
      >
        {/* Form */}
        <form onSubmit={handleLogin} className="space-y-5">
          <div className="space-y-2">
            <Label htmlFor="email" className="text-[#888888] text-sm font-body">
              Email
            </Label>
            <Input
              id="email"
              type="email"
              data-testid="login-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@gmail.com"
              className="bg-[#050505] border-[#333333] text-[#EDEDED] focus:border-[#00FF94] focus:ring-1 focus:ring-[#00FF94] placeholder:text-[#555555] rounded-sm h-11 font-mono"
              required
            />
          </div>

          <div className="space-y-2">
            <Label
              htmlFor="password"
              className="text-[#888888] text-sm font-body"
            >
              Senha
            </Label>
            <Input
              id="password"
              type="password"
              data-testid="login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="bg-[#050505] border-[#333333] text-[#EDEDED] focus:border-[#00FF94] focus:ring-1 focus:ring-[#00FF94] placeholder:text-[#555555] rounded-sm h-11 font-mono"
              required
            />
          </div>

          {error && (
            <p className="text-[#FF3B30] text-sm font-body">{error}</p>
          )}

          <Button
            type="submit"
            data-testid="login-submit-button"
            disabled={loading}
            className="w-full bg-[#00FF94] text-black hover:bg-[#00CC76] rounded-sm h-11 font-bold transition-all duration-150 font-body"
          >
            {loading ? (
              <Loader2 className="w-5 h-5 animate-spin" />
            ) : (
              "Entrar"
            )}
          </Button>
        </form>
      </div>
    </div>
  );
}
